import { ObjectExt, Dom } from '@antv/x6-common';
export const style = {
    qualify: ObjectExt.isPlainObject,
    set(styles, { elem }) {
        Dom.css(elem, styles);
    },
};
//# sourceMappingURL=style.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/x6/es/registry/attr/style.js
// module id = null
// module chunks = 